const TOKEN_STORAGE_KEY = 'lonvory.staff-location.device-token.v1';
const ACTIVATION_PARAMETER = 'lonvory-staff';

function activateStaffMode() {
  const fragment = window.location.hash.slice(1);
  if (!fragment) return;

  const parameters = new URLSearchParams(fragment);
  const token = parameters.get(ACTIVATION_PARAMETER)?.trim();
  if (!token) return;

  try {
    if (token.length >= 32) window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    // The product component remains hidden if browser storage is unavailable.
  }

  window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
}

activateStaffMode();
